import createTypedReducer from "@insite/client-framework/Common/CreateTypedReducer";
import { OrderModel } from "@insite/client-framework/Types/ApiModels";
import { Draft } from "immer";

export interface CustomModalsStateType {
    readonly orderNumber?: string;
    readonly orderData: { [key: string]: OrderModel };
    readonly modal: { [key: string]: boolean };
}

export type CustomModalsState = Readonly<CustomModalsStateType>;

export const initialCustomModalsState: CustomModalsState = {
    orderData: {},
    modal: {},
};

export const customModalsReducer = createTypedReducer(initialCustomModalsState, {
    "Custom/Modals/OrderData": (
        draft: Draft<CustomModalsState>,
        { orderNumber, orderData }: { orderNumber: string; orderData: OrderModel },
    ) => ({
        ...draft,
        orderData: {
            ...draft.orderData,
            [orderNumber]: orderData,
        },
    }),
    "Custom/Modals/SetModalVisibility": (
        draft: Draft<CustomModalsState>,
        { orderNumber, key, value }: { orderNumber: string; key: string; value: boolean },
    ) => ({
        ...draft,
        orderNumber,
        modal: {
            ...draft.modal,
            [key]: value,
        },
    }),
});
